import React, { useEffect, useState } from "react";
import { Table, Button, Form } from "react-bootstrap";
import { FaEdit, FaTrash } from "react-icons/fa";
import { form24QFields, getGridColumnTotal } from "../../utils/client/misc";
import moment from "moment";

const Form24QTable = ({
  data = [],
  onEdit = () => {},
  // onDelete = () => {},
  activePage,
  limit,
  setEmpIds = () => {},
  selectedMonth,
  isDataSendToCA,
  empIds = [],
}) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const marchOnlyFields = [
    // "ca",
    // "gp",
    "aa1",
    "aa2",
    "toa",
    // "toi",
    "an1",
    "an2",
    "lic",
    "ppf",
    "tf",
    "hp",
    "ti",
    "80c",
    "80d",
    "80u",
    "80g",
    "80b",
    "ccd",
    "ad1",
    "ad2",
    "pi",
    "nt",
    "ed",
    "eg",
    "rp",
    "adn",
    "ad3",
    "ad4",
    "ad5",
    "80ds",
    "80df",
    "80dd",
    "80ddb",
    "80e",
    "80tta",
    "80ttb",
  ];

  let totalBasic = 0;
  let totalDA = 0;
  let totalHRA = 0;
  let totalCCA = 0;
  let totalGradePay = 0;
  let totalArrear = 0;
  let totalBonus = 0;
  let totalIfAnyOtherIncome1 = 0;
  let totalIfAnyOtherIncome2 = 0;
  let totalTotalOtherIncome = 0;
  let totalIfAnyOtherAllowance1 = 0;
  let totalIfAnyOtherAllowance2 = 0;
  let totalTotalOtherAllowance = 0;
  let totalNPS = 0;
  let totalGrossTotal = 0;
  let totalGPF = 0;
  let totalGIS = 0;
  let totalLIC = 0;
  let totalPPF = 0;
  let totalTuitionFees = 0;
  let totalHouseLoanPrinciple = 0;
  let totalPLI = 0;
  let totalNPS80CCD = 0;
  let totalTermInsurance = 0;
  let totalDeduction80C = 0;
  let totalDeduction80D = 0;
  let totalDeduction80G = 0;
  let totalDeduction80U = 0;
  let totalDeduction80CCD = 0;
  let totalDeduction80DS = 0;
  let totalDeduction80DF = 0;
  let totalDeduction80DD = 0;
  let totalDeduction80DDB = 0;
  let totalDeduction80E = 0;
  let totalDeduction80TTA = 0;
  let totalDeduction80TTB = 0;
  let totalAnyOtherDeduction1 = 0;
  let totalAnyOtherDeduction2 = 0;
  let totalAnyOtherDeduction3 = 0;
  let totalAnyOtherDeduction4 = 0;
  let totalAnyOtherDeduction5 = 0;
  let totalIncomeTax = 0;
  let totalTotalDeduction = 0;
  let totalNetAmount = 0;

  // useEffect(() => {
  //   console.log("data", data);
  // });

  useEffect(() => {
    if (selectedMonth) {
      setSelectedIds([]);
      setEmpIds([]);
    }
  }, [selectedMonth]);

  totalBasic = getGridColumnTotal(data, activePage, limit, "ba");
  totalDA = getGridColumnTotal(data, activePage, limit, "da");
  totalHRA = getGridColumnTotal(data, activePage, limit, "hr");
  totalCCA = getGridColumnTotal(data, activePage, limit, "ca");
  totalGradePay = getGridColumnTotal(data, activePage, limit, "gp");
  totalArrear = getGridColumnTotal(data, activePage, limit, "ar");
  totalBonus = getGridColumnTotal(data, activePage, limit, "bo");
  totalIfAnyOtherIncome1 = getGridColumnTotal(data, activePage, limit, "an1");
  totalIfAnyOtherIncome2 = getGridColumnTotal(data, activePage, limit, "an2");
  totalTotalOtherIncome = getGridColumnTotal(data, activePage, limit, "toi");
  totalIfAnyOtherAllowance1 = getGridColumnTotal(
    data,
    activePage,
    limit,
    "aa1",
  );
  totalIfAnyOtherAllowance2 = getGridColumnTotal(
    data,
    activePage,
    limit,
    "aa2",
  );
  totalTotalOtherAllowance = getGridColumnTotal(data, activePage, limit, "toa");
  totalNPS = getGridColumnTotal(data, activePage, limit, "nps");
  totalGrossTotal = getGridColumnTotal(data, activePage, limit, "gt");
  totalGPF = getGridColumnTotal(data, activePage, limit, "gpf");
  totalGIS = getGridColumnTotal(data, activePage, limit, "gis");
  totalLIC = getGridColumnTotal(data, activePage, limit, "lic");
  totalPPF = getGridColumnTotal(data, activePage, limit, "ppf");
  totalTuitionFees = getGridColumnTotal(data, activePage, limit, "tf");
  totalHouseLoanPrinciple = getGridColumnTotal(data, activePage, limit, "hp");
  totalPLI = getGridColumnTotal(data, activePage, limit, "pi");
  totalNPS80CCD = getGridColumnTotal(data, activePage, limit, "ccd");
  totalTermInsurance = getGridColumnTotal(data, activePage, limit, "ti");
  totalDeduction80C = getGridColumnTotal(data, activePage, limit, "80c");
  totalDeduction80D = getGridColumnTotal(data, activePage, limit, "80d");
  totalDeduction80G = getGridColumnTotal(data, activePage, limit, "80g");
  totalDeduction80U = getGridColumnTotal(data, activePage, limit, "80u");
  totalDeduction80CCD = getGridColumnTotal(data, activePage, limit, "80b");

  totalDeduction80DS = getGridColumnTotal(data, activePage, limit, "80ds");
  totalDeduction80DF = getGridColumnTotal(data, activePage, limit, "80df");
  totalDeduction80DD = getGridColumnTotal(data, activePage, limit, "80dd");
  totalDeduction80DDB = getGridColumnTotal(data, activePage, limit, "80ddb");
  totalDeduction80E = getGridColumnTotal(data, activePage, limit, "80e");
  totalDeduction80TTA = getGridColumnTotal(data, activePage, limit, "80tta");
  totalDeduction80TTB = getGridColumnTotal(data, activePage, limit, "80ttb");

  totalAnyOtherDeduction1 = getGridColumnTotal(data, activePage, limit, "ad1");
  totalAnyOtherDeduction2 = getGridColumnTotal(data, activePage, limit, "ad2");
  totalAnyOtherDeduction3 = getGridColumnTotal(data, activePage, limit, "ad3");
  totalAnyOtherDeduction4 = getGridColumnTotal(data, activePage, limit, "ad4");
  totalAnyOtherDeduction5 = getGridColumnTotal(data, activePage, limit, "ad5");
  totalIncomeTax = getGridColumnTotal(data, activePage, limit, "it");
  totalTotalDeduction = getGridColumnTotal(data, activePage, limit, "td");
  totalNetAmount = getGridColumnTotal(data, activePage, limit, "na");

  // Select All checkbox
  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);

    if (checked) {
      const allIds = data
        ?.slice((activePage - 1) * limit, activePage * limit)
        .map((row) => row.id);
      setSelectedIds(allIds);
      setEmpIds(allIds);
    } else {
      setSelectedIds([]);
      setEmpIds([]);
    }
  };

  useEffect(() => {
    if (empIds?.length == 0) {
      setSelectAll(false);
    } else {
      setSelectAll(true);
    }
  }, [empIds]);

  const handleCheckboxChange = (e, id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
    setEmpIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const visibleColumns = ["en", "pa", "adn", "de"];

  return (
    <>
      <Table striped bordered hover className="w-100 custom-table-form24">
        <thead className="table-light">
          <tr>
            <th className="sticky-col col-1 sno" style={{ width: "50px" }}>
              SNo
            </th>
            <th className="sticky-col col-1" style={{ width: "50px" }}>
              {/* <FaTrash
                style={{
                  color: "#2c3e50",
                  fontSize: "0.8rem",
                  cursor: "default",
                }}
              /> */}
              <Form.Group>
                <Form.Check
                  type="checkbox"
                  disabled={isDataSendToCA}
                  checked={selectAll}
                  onChange={handleSelectAll}
                  // tabIndex={info?.tab}
                  className="text-primary"
                />
              </Form.Group>
            </th>
            <th
              className="sticky-col col-2"
              style={{ width: "100px", textAlign: "center" }}
            >
              Action
            </th>
            {/* {form24QFields.map((col) =>
              marchOnlyFields.includes(col.key) &&
              selectedMonth !== "Mar" ? null : (
                <th
                  style={{ width: col.width, display: col?.display }} //display used for parmanent show/hide
                  className={col.className || ""}
                >
                  {col.label}
                  
                </th>
              ),
            )}*/}
            {form24QFields.map((col) =>
              visibleColumns.includes(col.key) ? (
                <th
                  key={col.key}
                  style={{ width: col.width, display: col?.display }}
                  className={col.className || ""}
                >
                  {col.label}
                </th>
              ) : null,
            )}
          </tr>
        </thead>
        <tbody>
          {data
            ?.slice((activePage - 1) * limit, activePage * limit)
            .map((info, index) => (
              <tr key={index}>
                <td className="text-center sno">
                  {index + 1 + limit * (activePage - 1)}
                </td>
                <td className="text-center">
                  {/* <FaTrash
                    style={{
                      color: "#2c3e50",
                      fontSize: "0.80rem",
                      cursor: "pointer",
                    }}
                    onClick={() => onDelete(info?.id)}
                  /> */}
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      disabled={isDataSendToCA}
                      checked={selectedIds.includes(info?.id)}
                      onChange={(e) => handleCheckboxChange(e, info?.id)}
                      // tabIndex={info?.tab}
                      className="text-primary bright-checkbox"
                    />
                  </Form.Group>
                </td>
                <td className=" text-center">
                  <Button variant="link" onClick={() => onEdit(info)}>
                    <FaEdit style={{ cursor: "pointer", color: "#2c3e50" }} />
                  </Button>
                </td>
                {/* {form24QFields.map((col) =>
                  marchOnlyFields.includes(col.key) &&
                  selectedMonth !== "Mar" ? null : (
                    <td
                      key={col.key}
                      style={{ display: col?.display }}
                      className={col.className || ""}
                    >
                      {info?.[col.key] ?? ""}
                    </td>
                  )
                )} */}
                {/* {form24QFields.map((col) =>
                  marchOnlyFields.includes(col.key) &&
                  selectedMonth !== "Mar" ? null : (
                    <td
                      key={col.key}
                      style={{ display: col?.display }}
                      className={col.className || ""}
                    >                      
                      {col.key === "ed"
                        ? info?.[col.key]
                          ? moment(
                              info[col.key],
                              ["DD/MMM/YYYY", "YYYY-MM-DD"],
                              true,
                            ).isValid()
                            ? moment(info[col.key], [
                                "DD/MMM/YYYY",
                                "YYYY-MM-DD",
                              ]).format("DD-MM-YYYY")
                            : ""
                          : ""
                        : col.key === "nt"
                          ? info?.[col.key] === 0
                            ? "No"
                            : "Yes"
                          : (info?.[col.key] ?? "")}
                    </td>
                  ),
                )} */}
                {/* {form24QFields.map((col) =>
                  marchOnlyFields.includes(col.key) &&
                  selectedMonth !== "Mar" ? null : (
                    <td
                      key={col.key}
                      style={{ display: col?.display }}
                      className={col.className || ""}
                    >
                      {col.key === "ed"
                        ? info?.[col.key]
                          ? moment(
                              info[col.key],
                              ["DD/MMM/YYYY", "YYYY-MM-DD"],
                              true,
                            ).isValid()
                            ? moment(info[col.key], [
                                "DD/MMM/YYYY",
                                "YYYY-MM-DD",
                              ]).format("DD-MM-YYYY")
                            : ""
                          : ""
                        : col.key === "nt"
                          ? info?.[col.key] === 0
                            ? "No"
                            : "Yes"
                          : col.key === "age"
                            ? info?.["ed"]
                              ? moment().diff(
                                  moment(info["ed"], "YYYY-MM-DD"),
                                  "years",
                                )
                              : ""
                            : (info?.[col.key] ?? "")}
                    </td>
                  ),
                )} */}
                {form24QFields.map((col) =>
                  visibleColumns.includes(col.key) ? (
                    <td
                      key={col.key}
                      style={{ display: col?.display }}
                      className={col.className || ""}
                    >
                      {col.key === "ed"
                        ? info?.[col.key]
                          ? moment(
                              info[col.key],
                              ["DD/MMM/YYYY", "YYYY-MM-DD"],
                              true,
                            ).isValid()
                            ? moment(info[col.key], [
                                "DD/MMM/YYYY",
                                "YYYY-MM-DD",
                              ]).format("DD-MM-YYYY")
                            : ""
                          : ""
                        : col.key === "nt"
                          ? info?.[col.key] === 0
                            ? "No"
                            : "Yes"
                          : col.key === "age"
                            ? info?.["ed"]
                              ? moment().diff(
                                  moment(info["ed"], "YYYY-MM-DD"),
                                  "years",
                                )
                              : ""
                            : (info?.[col.key] ?? "")}
                    </td>
                  ) : null,
                )}
              </tr>
            ))}
          {/* {
            data?.map((info, index) => (
              <tr key={index}>
                <td className="sticky-col col-1 text-center"></td>
                <td className="sticky-col col-1 text-center"></td>
                <td className="sticky-col col-2 text-center"></td>
                {form24QFields.map((col) =>
                  marchOnlyFields.includes(col.key) &&
                  selectedMonth !== "Mar" ? null : (
                    <td
                      key={col.key}
                      style={{ fontWeight: "bold", display: col?.display }}
                      className={col.className || ""}
                    >
                      {col.key == "en" //Employee Name
                        ? "TOTAL"
                        : col.key == "pa" //PAN
                          ? ""
                          : col.key == "de" //Designation
                            ? ""
                            : col.key == "ed" //dob
                              ? ""
                              : col.key == "eg" //gender
                                ? ""
                                : col.key == "ead" //address
                                  ? ""
                                  : col.key == "ec" //city
                                    ? ""
                                    : col.key == "es" //state
                                      ? ""
                                      : col.key == "age" //age
                                        ? ""
                                        : col.key == "epc" //age
                                          ? ""
                                          : col.key == "eco" //country
                                            ? ""
                                            : col.key == "adn" //aadhar
                                              ? ""
                                              : col.key == "ba" //Basic
                                                ? totalBasic
                                                : col.key == "da" //D.A.
                                                  ? totalDA
                                                  : col.key == "hr" //H.R.A.
                                                    ? totalHRA
                                                    : col.key == "ca" //C.C.A.
                                                      ? totalCCA
                                                      : col.key == "gp" //Grade Pay
                                                        ? totalGradePay
                                                        : col.key == "ar" //Arrear
                                                          ? totalArrear
                                                          : col.key == "bo" //Bonus
                                                            ? totalBonus
                                                            : col.key == "an1" //If Any Other Income
                                                              ? totalIfAnyOtherIncome1
                                                              : col.key == "an2" //If Any Other Income
                                                                ? totalIfAnyOtherIncome2
                                                                : col.key ==
                                                                    "toi" //Total Other Income
                                                                  ? totalTotalOtherIncome
                                                                  : col.key ==
                                                                      "aa1" //If Any Other Allowance1
                                                                    ? totalIfAnyOtherAllowance1
                                                                    : col.key ==
                                                                        "aa2" //If Any Other Allowance2
                                                                      ? totalIfAnyOtherAllowance2
                                                                      : col.key ==
                                                                          "toa" //Total Other Allowance
                                                                        ? totalTotalOtherAllowance
                                                                        : col.key ==
                                                                            "nps" //Employer's Contribution (NPS)
                                                                          ? totalNPS
                                                                          : col.key ==
                                                                              "gt" //Gross Total
                                                                            ? totalGrossTotal
                                                                            : col.key ==
                                                                                "gpf" //G.P.F.
                                                                              ? totalGPF
                                                                              : col.key ==
                                                                                  "gis" //G.I.S.
                                                                                ? totalGIS
                                                                                : col.key ==
                                                                                    "lic" //LIC
                                                                                  ? totalLIC
                                                                                  : col.key ==
                                                                                      "ppf" //PPF
                                                                                    ? totalPPF
                                                                                    : col.key ==
                                                                                        "tf" //Tuition Fees
                                                                                      ? totalTuitionFees
                                                                                      : col.key ==
                                                                                          "hp" //House Loan Principle
                                                                                        ? totalHouseLoanPrinciple
                                                                                        : col.key ==
                                                                                            "pi" //P.L.I.
                                                                                          ? totalPLI
                                                                                          : col.key ==
                                                                                              "ccd" //N.P.S. u/s 80CCD(1)
                                                                                            ? totalNPS80CCD
                                                                                            : col.key ==
                                                                                                "ti" //Term Insurance
                                                                                              ? totalTermInsurance
                                                                                              : col.key ==
                                                                                                  "80c" //Deduction u/s 80C
                                                                                                ? totalDeduction80C
                                                                                                : col.key ==
                                                                                                    "80d" //Deduction u/s 80D
                                                                                                  ? totalDeduction80D
                                                                                                  : col.key ==
                                                                                                      "80g" //Deduction u/s 80G
                                                                                                    ? totalDeduction80G
                                                                                                    : col.key ==
                                                                                                        "80u" //Deduction u/s 80U
                                                                                                      ? totalDeduction80U
                                                                                                      : col.key ==
                                                                                                          "80b" //Deduction u/s 80CCD 1B
                                                                                                        ? totalDeduction80CCD
                                                                                                        : col.key ==
                                                                                                            "80ds" //Deduction u/s 80D Self
                                                                                                          ? totalDeduction80DS
                                                                                                          : col.key ==
                                                                                                              "80df" //Deduction u/s 80D Family
                                                                                                            ? totalDeduction80DF
                                                                                                            : col.key ==
                                                                                                                "80dd" //Deduction u/s 80DD
                                                                                                              ? totalDeduction80DD
                                                                                                              : col.key ==
                                                                                                                  "80ddb" //Deduction u/s 80DDB
                                                                                                                ? totalDeduction80DDB
                                                                                                                : col.key ==
                                                                                                                    "80e" //Deduction u/s 80E
                                                                                                                  ? totalDeduction80E
                                                                                                                  : col.key ==
                                                                                                                      "80tta" //Deduction u/s 80TTA
                                                                                                                    ? totalDeduction80TTA
                                                                                                                    : col.key ==
                                                                                                                        "80ttb" //Deduction u/s 80TTB
                                                                                                                      ? totalDeduction80TTB
                                                                                                                      : col.key ==
                                                                                                                          "ad1" //Any Other Deduction
                                                                                                                        ? totalAnyOtherDeduction1
                                                                                                                        : col.key ==
                                                                                                                            "ad2" //Any Other Deduction
                                                                                                                          ? totalAnyOtherDeduction2
                                                                                                                          : col.key ==
                                                                                                                              "ad3" //Any Other Deduction
                                                                                                                            ? totalAnyOtherDeduction3
                                                                                                                            : col.key ==
                                                                                                                                "ad4" //Any Other Deduction
                                                                                                                              ? totalAnyOtherDeduction4
                                                                                                                              : col.key ==
                                                                                                                                  "ad5" //Any Other Deduction
                                                                                                                                ? totalAnyOtherDeduction5
                                                                                                                                : col.key ==
                                                                                                                                    "it" //Income Tax
                                                                                                                                  ? totalIncomeTax
                                                                                                                                  : col.key ==
                                                                                                                                      "td" //Total Deduction
                                                                                                                                    ? totalTotalDeduction
                                                                                                                                    : col.key ==
                                                                                                                                        "na" //Net Amount
                                                                                                                                      ? totalNetAmount
                                                                                                                                      : col.key ==
                                                                                                                                          "nt" //Designation
                                                                                                                                        ? ""
                                                                                                                                        : col.key}
                    </td>
                  ),
                )}
              </tr>
            ))[0]
          } */}
        </tbody>
      </Table>
    </>
  );
};

export default Form24QTable;
